import React from 'react';
import './Contact.css';

function Contact() {
  return (
    <div className="service-page">
      {/* Hero Section */}
      <section
        className="hero-image-section"
        style={{ backgroundImage: "url('/images/contact_us.png')" }}
      >
        <div className="hero-text-container">
          <h1>Contact Details</h1>
          <p>We are here to support your financial journey 24/7</p>
        </div>
      </section>

      {/* Contact Info + Form Section */}
      <section className="contact-grid-section">
        <div className="contact-info">
          {/* Head Office (Link to Google Maps) */}
          <a
            href="https://www.google.com/maps/place/1st+Floor,+JAWAHARLAL+NEHRU+TECHNOLOGICAL+UNIVERSITY,+Plot+No.+92,+Road+No.+4,+Vasanth+Nagar,+Kukatpally,+Hyderabad,+Telangana+500085"
            target="_blank"
            rel="noopener noreferrer"
            className="contact-card"
            style={{ textDecoration: 'none', color: 'inherit', cursor: 'pointer' }}
          >
            <div className="contact-icon">
              <img src="/images/location.png" alt="Location" />
            </div>
            <h3>Head Office</h3>
            <p>
              Plot No. 92, Road No. 4, Vasanth Nagar Colony,<br />
              Hyderabad - 500085
            </p>
          </a>

          {/* Contact Us (WhatsApp Link) */}
          <a
            href="https://wa.me/919603059997"
            target="_blank"
            rel="noopener noreferrer"
            className="contact-card"
            style={{ textDecoration: 'none', color: 'inherit' }}
          >
            <div className="contact-icon">
              <img src="/images/phone.png" alt="WhatsApp" />
            </div>
            <h3>Contact Us</h3>
            <p>+91 9603059997</p>
          </a>

          {/* For Hiring (WhatsApp Link) */}
          <a
            href="https://wa.me/917569523497"
            target="_blank"
            rel="noopener noreferrer"
            className="contact-card"
            style={{ textDecoration: 'none', color: 'inherit' }}
          >
            <div className="contact-icon">
              <img src="/images/hiring.png" alt="Hiring" />
            </div>
            <h3>For Hiring</h3>
            <p>+91 7569523497</p>
          </a>

          {/* Email (MailTo) */}
          <a
            href="mailto:info@fintexl.com"
            className="contact-card"
            style={{ textDecoration: 'none', color: 'inherit' }}
          >
            <div className="contact-icon">
              <img src="/images/gmail.png" alt="Email" />
            </div>
            <h3>Email</h3>
            <p>info@fintexl.com</p>
          </a>
        </div>

        {/* Contact Form */}
        <div className="contact-form-wrapper">
          <h2>Get In Touch</h2>
          <form className="contact-form-style">
            <div className="row">
              <input type="text" placeholder="First Name" />
              <input type="text" placeholder="Last Name" />
            </div>
            <div className="row">
              <input type="email" placeholder="Email" />
              <select>
                <option>Select Your Services</option>
                <option>Virtual CFO Services</option>
                <option>Bookkeeping & Accounting</option>
                <option>Taxation Services</option>
                <option>Corporate Law & Secretarial</option>
                <option>Startup Consulting</option>
                <option>Business Advisory</option>
                <option>International Business</option>
                <option>Payroll & HR Services</option>
                <option>Others</option>
              </select>
            </div>
            <input type="text" placeholder="Phone Number" />
            <textarea placeholder="Comments" rows="4"></textarea>
            <button type="submit">SUBMIT</button>
          </form>
        </div>
      </section>

      {/* Location Section (Optional Keep or Remove) */}
      <section className="location-section">
        <div className="location-card">
          <img src="/images/charminar.jpg" alt="Fintexl Office" className="location-img" />
          <div className="location-details">
            <h4>INDIA, HYDERABAD</h4>
            <p>
              Plot No. 92, Road No. 4, Vasanth Nagar,<br />
              Kukatpally, Hyderabad, Telangana - 500085
            </p>
          </div>
          <div className="map-frame">
            <iframe
              title="Fintexl Location Map"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3803.798555716156!2d78.3871282!3d17.4967474!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb91f345555555%3A0x5293a666ef676b70!2s1st%20Floor%2C%20JAWAHARLAL%20NEHRU%20TECHNOLOGICAL%20UNIVERSITY%2C%20Plot%20No.%2092%2C%20Road%20No.%204%2C%20Vasanth%20Nagar%2C%20Kukatpally%2C%20Hyderabad%2C%20Telangana%20500085!5e0!3m2!1sen!2sin!4v1687775000000!5m2!1sen!2sin"
              width="100%"
              height="250"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
            ></iframe>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Contact;









